import React, { Component } from "react";

import Slider from "../../SliderView/MainSlider";
import api from "../../../Environment";
import ContentLoader from "../../Static/contentLoader";
import Helper from "../../Helper/helper";
import BrandAssetManager from "../../../branding/BrandAssetManager";

class Wishlist extends Helper {
  state = {
    wishlists: [],
    loading: true,
  };
  componentDidMount() {
    const inputData = {
      skip: 0,
    };
    api
      .postMethod("wishlists/list", inputData)
      .then((response) => {
        if (response.data.success === true) {
          const wishlists = Array.isArray(response.data.data)
            ? response.data.data
            : [];
          this.setState({ loading: false, wishlists: wishlists });
        } else {
          this.errorCodeChecker(response.data.error_code);
          this.setState({ loading: false, wishlists: [] });
        }
      })
      .catch(() => {
        this.setState({ loading: false, wishlists: [] });
      });
  }

  chunkArray(myArray, chunk_size) {
    let results = [];
    const source = Array.isArray(myArray) ? [...myArray] : [];

    while (source.length) {
      results.push(source.splice(0, chunk_size));
    }

    return results;
  }

  render() {
    if (this.state.loading) {
      return <ContentLoader />;
    }

    const wishlists = this.state.wishlists || [];
    const result = this.chunkArray(wishlists, 5);
    const collectionName = BrandAssetManager.collectionLabel();

    return (
      <div className="main p-40">
        <div className="main-slidersec">
          <h3 className="">
            {collectionName}
            <i className="fas fa-angle-right ml-2" />
          </h3>
          {result.length === 0 ? (
            <p className="text-muted">
              Nothing in {collectionName} yet. Add titles from Home or Video
              Details to see them here.
            </p>
          ) : (
            result.map((res, index) => (
              <Slider key={`wishlist-row-${index}`}>
                {res.map((movie) => (
                  <Slider.Item movie={movie} key={movie.admin_video_id}>
                    item1
                  </Slider.Item>
                ))}
              </Slider>
            ))
          )}
        </div>
        <div className="height-100" />
      </div>
    );
  }
}

export default Wishlist;
